module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwAgMAAAAqbBEUAAAADFBMVEUAAAD//wDiu2/junDguAAVAAAAA3RSTlMAAZeNBvN4AAAAWElEQVQoz03LsQHAMAzDMHfpEz3SJ/Y0Zgw0UQNm7l56Ps/Szy9J4tkkSZIkSZIkSZIkSZIkSZIkSZIkSZIkSZIkSZIkSZIkSZIkSZIkSZIkSZIkSZIG0gEGchbHa6mdzQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/kline/more-2.png
// module id = NaU2
// module chunks = 1